import React from "react";

// Source
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerTaskCalendar from "../../controller/custom/TaskCalendar";
import ControllerLocalization from "../../controller/Localization";
import ViewLoader from "../Loader";
import ViewDialog from "../../view/Dialog";

let isRendered = false;

const viewPageTaskCalendar: React.FC = () => {
    // Variable
    const controllerTaskCalendar = new ControllerTaskCalendar(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerTaskCalendar.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <div className="view_task_calendar" data-at_id="view_task_calendar">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerTaskCalendar.getDataMain && controllerTaskCalendar.getSelectOption) {
                        html.push(
                            <ViewDialog
                                className="task_detail_dialog"
                                isOpen={controllerTaskCalendar.getIsTaskDetailDialogOpen}
                                isApiLoading={false}
                                labelConfirm={controllerLocalization.getStorageMain.close}
                                onClickConfirm={controllerTaskCalendar.clickTaskDetailDialogClose}
                                labelCancel={""}
                                onClickCancel={() => {
                                    //...
                                }}
                                mode={""}
                                content={
                                    <div>
                                        <div className="title">{controllerLocalization.getStorageMain.task_detail}</div>
                                        <div className="detail">
                                            <div className="row">
                                                <p>
                                                    <b>{controllerLocalization.getStorageMain.id}: </b>
                                                    {controllerTaskCalendar.getDataMain.id || ""}
                                                </p>
                                            </div>
                                            <div className="row">
                                                <p>
                                                    <b>{controllerLocalization.getStorageMain.name}: </b>
                                                    <span
                                                        className="click"
                                                        onClick={(event) => {
                                                            controllerTaskCalendar.clickItemDetail(event, controllerTaskCalendar.getDataMain);
                                                        }}
                                                    >
                                                        {controllerTaskCalendar.getDataMain.name || ""}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="row">
                                                <p>
                                                    <b>{controllerLocalization.getStorageMain.member}: </b>
                                                    {(() => {
                                                        for (const optionData of Object.values(controllerTaskCalendar.getSelectOption.user_id)) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            if (controllerTaskCalendar.getDataMain.member_id === optionDataTyped.value) {
                                                                return optionDataTyped.display_name;
                                                            }
                                                        }
                                                    })()}
                                                </p>
                                            </div>
                                            <div className="row">
                                                <p>
                                                    <b>{controllerLocalization.getStorageMain.day}: </b>
                                                    {controllerTaskCalendar.getDataMain.day || ""}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="title">{controllerLocalization.getStorageMain.description}</div>
                                        <textarea className="message" defaultValue={controllerTaskCalendar.getDataMain.description || ""} />
                                    </div>
                                }
                            />
                        );
                    }

                    return html;
                })()}
                {(() => {
                    const html: JSX.Element[] = [];

                    html.push(
                        <ViewDialog
                            className="task_list_dialog"
                            isOpen={controllerTaskCalendar.getIsTaskListDialogOpen}
                            isApiLoading={false}
                            labelConfirm={controllerLocalization.getStorageMain.close}
                            onClickConfirm={controllerTaskCalendar.clickTaskListDialogClose}
                            labelCancel={""}
                            onClickCancel={() => {
                                //...
                            }}
                            mode={""}
                            content={
                                <div>
                                    <div className="title">
                                        {controllerLocalization.getStorageMain.task} {controllerLocalization.getStorageMain.list}
                                    </div>
                                    <div className="detail">
                                        {(() => {
                                            const html: JSX.Element[] = [];

                                            if (controllerTaskCalendar.getTaskDay && controllerTaskCalendar.getDataMainList) {
                                                for (const task of controllerTaskCalendar.getDataMainList) {
                                                    const taskDate = new Date(task.day);

                                                    if (controllerTaskCalendar.getTaskDay === taskDate.getDate()) {
                                                        html.push(
                                                            <div className="row">
                                                                <p>
                                                                    <span
                                                                        className="click"
                                                                        onClick={() => {
                                                                            controllerTaskCalendar.clickTask(task);
                                                                        }}
                                                                    >
                                                                        {task.id}: {task.name}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        );
                                                    }
                                                }
                                            }

                                            return html;
                                        })()}
                                    </div>
                                </div>
                            }
                        />
                    );

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageTaskCalendar;
